import {
  Popover,
  PopoverTrigger,
  PopoverContent
} from "shared/components/Popover";
import {
  Checkbox,
  CheckboxSize,
  Button,
  ButtonVariant,
  ButtonSize
} from "shared/components";
import { Card } from "shared/components/Card";
import { HugeiconsIcon } from "@hugeicons/react";
import { ArrowDown01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";
import { LEAD_TYPE_OPTIONS, LeadType } from "views/leads-id/types";
import { LeadTypeBadge } from "./LeadTypeBadge";
import { getLeadTypesLabel } from "../utils/leadTypeFilter";

const NOOP = () => {};

const LEAD_TYPE_ORDER: Record<LeadType, number> = {
  [LeadType.Owner]: 0,
  [LeadType.Tenant]: 1
};

const POPOVER_LEAD_TYPE_OPTIONS = LEAD_TYPE_OPTIONS.toSorted(
  (a, b) => LEAD_TYPE_ORDER[a.value] - LEAD_TYPE_ORDER[b.value]
);

interface LeadTypeFilterPopoverProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedLeadTypes: LeadType[];
  onSelectedLeadTypesChange: (leadTypes: LeadType[]) => void;
}

export const LeadTypeFilterPopover = ({
  open,
  onOpenChange,
  selectedLeadTypes,
  onSelectedLeadTypesChange
}: LeadTypeFilterPopoverProps) => {
  const handleToggle = (leadType: LeadType) => {
    const isSelected = selectedLeadTypes.includes(leadType);
    onSelectedLeadTypesChange(
      isSelected
        ? selectedLeadTypes.filter((type) => type !== leadType)
        : [...selectedLeadTypes, leadType]
    );
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange} placement="bottom-start">
      <PopoverTrigger onClick={() => onOpenChange(true)}>
        <Card className="w-fit px-4 py-2 flex items-center gap-2 min-h-[40px] h-full shadow-xs">
          <span className="text-content-200 font-bold text-xs shrink-0">
            Type:
          </span>
          <span className="font-bold text-content-1000 text-xs truncate">
            {getLeadTypesLabel(selectedLeadTypes)}
          </span>
          <HugeiconsIcon
            icon={ArrowDown01Icon}
            size={16}
            className={cx(
              "text-content-1000 shrink-0",
              open ? "rotate-180" : ""
            )}
          />
        </Card>
      </PopoverTrigger>
      <PopoverContent className="max-w-[240px] w-full p-0 rounded-lg border border-alpha-100 shadow-lg bg-content-1000-inverted z-10">
        <div className="flex w-full items-center justify-between gap-3 px-4 py-3 border-b border-alpha-40">
          <span className="text-sm font-bold text-content-1000">Type:</span>
          <Button
            type="button"
            variant={ButtonVariant.TEXT}
            size={ButtonSize.SM}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
        </div>
        <div className="py-1">
          {POPOVER_LEAD_TYPE_OPTIONS.map((option) => (
            <div
              key={option.value}
              className="flex w-full items-center gap-3 px-4 py-2.5 hover:bg-alpha-40 cursor-pointer"
              onClick={() => handleToggle(option.value)}
            >
              <Checkbox
                checked={selectedLeadTypes.includes(option.value)}
                size={CheckboxSize.SM}
                wrapperClassName="!w-auto !flex-none !p-0 justify-center"
                onChange={NOOP}
              />
              <LeadTypeBadge leadType={option.value} />
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
